/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AuditStatusEnum } from './auditStatusEnum';
import { AuditData } from './auditData';


export interface AuditLogSpec { 
    audit_data: AuditData;
    /**
     * Reason why the Audit publishing failed. Error message from CSP Audit SDK
     */
    error_msg?: string;
    status: AuditStatusEnum;
}
export namespace AuditLogSpec {
}


